import apiClient from './apiClient';

const _postAndDownload = async (url, body, fallbackName) => {
  let response;
  try {
    response = await apiClient.post(url, body, { responseType: 'blob' });
  } catch (err) {
    const blob = err?.response?.data;
    if (blob instanceof Blob) {
      const text = await blob.text();
      try {
        const parsed = JSON.parse(text);
        const apiErr = new Error(parsed.detail || 'Eroare la generarea documentului');
        apiErr.missing = parsed.missing || [];
        throw apiErr;
      } catch (parseErr) {
        if (parseErr.missing !== undefined) throw parseErr;
      }
    }
    throw err;
  }
  const disposition = response.headers['content-disposition'] || '';
  const match = disposition.match(/filename="(.+?)"/);
  const filename = match ? match[1] : fallbackName;
  const url2 = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
  const a = document.createElement('a');
  a.href = url2;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url2);
};

export const generateContract = (clientId, company) =>
  _postAndDownload(
    `/clienti/${clientId}/generate-contract/`,
    { company },
    `Contract ${company}.pdf`
  );

export const generateDocument = (clientId, tip, company, nr) =>
  _postAndDownload(
    `/clienti/${clientId}/generate-document/`,
    { tip, company, ...(nr !== undefined ? { nr } : {}) },
    `${tip} ${company}.pdf`
  );

export const redownloadDocument = (clientId, docId) =>
  _postAndDownload(
    `/clienti/${clientId}/generate-document/`,
    { doc_id: docId },
    `document-${docId}.pdf`
  );

export const listGeneratedDocs = (clientId, tip, company) =>
  apiClient.get(`/clienti/${clientId}/generate-document/`, { params: { tip, company } });
